import { IThongKeCanXuLy } from "../../../api/dashboard/thongKeCanXuLyApi";
import { IThongKeCanXuLyActionTypes } from "../../action-types/dashboard/IThongKeCanXuLyActionTypes";
import { IThongKeCanXuLyReducer } from "../../reducer-model/dashboard/IThongKeCanXuLyReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

export const RONG_THONG_KE: IThongKeCanXuLy = {
  bo_sung_hoc_phan: 0,
  chua_xuat_hoa_don: 0,
  muc_thu_chua_duyet: 0,
  hoc_phan_gia_0: 0,
  con_tien_trong_vi: 0,
  thoi_hoc_con_no: 0,
  rut_hoc_phan: 0,
  huy_dang_ky: 0,
  thu_thua: 0,
  mien_giam_cho_duyet: 0,
  thi_lai_cho_duyet: 0,
  hoc_bu_cho_duyet: 0,
  hoc_lai_cho_duyet: 0,
  tong: 0,
};

const iniState: IThongKeCanXuLyReducer = {
  data: RONG_THONG_KE,
  status: eReducerStatusBase.is_not_initialization,
  daTai: false,
  coThayDoi: false,
  hoc_ky: 0,
  nam_hoc: "",
};

const khacNhau = (a: IThongKeCanXuLy, b: IThongKeCanXuLy) =>
  (Object.keys(RONG_THONG_KE) as (keyof IThongKeCanXuLy)[]).some(
    (k) => a[k] !== b[k],
  );

/**
 * Thống kê "việc còn tồn" của kỳ đang xem — MỘT bộ số dùng chung cho chuông thông báo và Dashboard,
 * nên hai nơi không bao giờ nói hai con số khác nhau và cũng chỉ gọi máy chủ một lần.
 */
export const thongKeCanXuLyReducer = (
  state: IThongKeCanXuLyReducer = iniState,
  action: IThongKeCanXuLyActionTypes,
): IThongKeCanXuLyReducer => {
  switch (action.type) {
    case "THONG_KE_CAN_XU_LY_LOAD_START": {
      const doiKy =
        state.hoc_ky !== action.payload.hoc_ky ||
        state.nam_hoc !== action.payload.nam_hoc;
      // Đổi kỳ/năm = bối cảnh khác hẳn ⇒ vứt số cũ, bỏ mốc so sánh, quay về trạng thái chưa tải.
      return doiKy
        ? {
            ...iniState,
            status: eReducerStatusBase.is_loading,
            hoc_ky: action.payload.hoc_ky,
            nam_hoc: action.payload.nam_hoc,
          }
        : { ...state, status: eReducerStatusBase.is_loading };
    }

    case "THONG_KE_CAN_XU_LY_LOAD_SUCCESS": {
      // Kết quả của kỳ KHÁC về muộn thì bỏ, không được đè lên kỳ đang xem.
      if (
        action.payload.hoc_ky !== state.hoc_ky ||
        action.payload.nam_hoc !== state.nam_hoc
      )
        return state;
      return {
        ...state,
        data: action.payload.data,
        status: eReducerStatusBase.is_completed,
        daTai: true,
        // Lần quét ĐẦU chỉ ghi nhận; từ lần sau mới báo — không thì vừa mở phần mềm đã nảy thông báo.
        coThayDoi:
          state.daTai && khacNhau(state.data, action.payload.data)
            ? true
            : state.coThayDoi,
      };
    }

    case "THONG_KE_CAN_XU_LY_LOAD_ERRR":
      // Thống kê phụ trợ — hỏng thì giữ nguyên số cũ, KHÔNG phá giao diện.
      return { ...state, status: eReducerStatusBase.is_completed };

    case "THONG_KE_CAN_XU_LY_DA_XEM":
      return { ...state, coThayDoi: false };

    default:
      return state;
  }
};
